/* @flow */

import { combineReducers } from 'redux';

import marketAutocompleteTopicReducer from './marketAutocompleteTopicReducer';
import marketAutocompleteUserReducer from './marketAutocompleteUserReducer';
import * as namespaces from 'src/shared/app/market/action/marketActionNamespaces';
import { createFilteredReducer } from 'src/shared/core/util/reducerUtils';

// $FlowIssue
export default combineReducers({
  topic: createFilteredReducer(
    marketAutocompleteTopicReducer,
    (action) => action.namespace === namespaces.MARKET_AUTOCOMPLETE_TOPICS,
  ),
  user: createFilteredReducer(
    marketAutocompleteUserReducer,
    (action) => action.namespace === namespaces.MARKET_AUTOCOMPLETE_USERS,
  ),
});
